<div #leafletContainer [id]="id" class="map-wrapper leaflet-container {{ currentMode }}-{{ currentAction }}-mode">
    <map-actions [map]="map" *ngIf="map && id === 'map'"></map-actions>
    <map-selection [map]="map"></map-selection>
</div>
